import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Loading from '../components/Loading/Loading';

function Offer() {
    return (
        <div className={`body_container`}>
            <Suspense fallback={<Loading />}>
                <Outlet />
            </Suspense>
        </div>
    );
}

export default Offer;